<template>
  <div>
    <div class="title">当前手机号：{{ phone }}</div>
    <div class="form">
      <Form
        ref="formValidate"
        :model="formValidate"
        :label-width="80"
        :rules="ruleValidate"
      >
        <FormItem label="验证码" prop="checkNum">
          <i-input
            v-model="formValidate.checkNum"
            size="large"
            placeholder="请输入验证码"
          >
            <Button
              slot="append"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="getcheckNum"
            >
              {{ text }}
            </Button>
          </i-input>
        </FormItem>
        <FormItem label="新密码" prop="password">
          <i-input
            type="password"
            v-model="formValidate.password"
            clearable
            size="large"
            placeholder="请输入你的新密码"
          ></i-input>
        </FormItem>
        <FormItem label="确认密码" prop="repassword">
          <i-input
            type="password"
            v-model="formValidate.repassword"
            clearable
            size="large"
            placeholder="请再次输入你的密码"
          ></i-input>
        </FormItem>
      </Form>
      <div class="btn" @click="confirm">确认修改</div>
    </div>
  </div>
</template>

<script>
import {
  getUserInfo,
  getCodeApi,
  registerVerify,
  registerReset
} from "@api/user";
import sendVerifyCode from "@/mixins/SendVerifyCode";
export default {
  name: "ChangePassword",
  mixins: [sendVerifyCode],
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formValidate.password) {
        callback(new Error("两次输入的密码不一样"));
      } else {
        callback();
      }
    };
    return {
      keyCode: "",
      phone: "",
      formValidate: {
        phone: "",
        checkNum: "",
        password: "",
        repassword: ""
      },
      ruleValidate: {
        checkNum: [
          { required: true, message: "必须填写验证码", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 6,
            message: "验证码长度错误",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码长度不能小于6",
            trigger: "blur"
          }
        ],
        repassword: [
          { required: true, validator: validatePassCheck, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getUserInfo();
    this.getCode();
  },
  methods: {
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$Message.error(res.msg);
        });
    },
    getcheckNum() {
      const data = {
        phone: this.formValidate.phone,
        key: this.keyCode,
        code: ""
      };
      registerVerify(data)
        .then(res => {
          if (res.status === 200) {
            this.$Message.success({
              content: "验证码已发送",
              duration: 6,
              closable: true
            });
            this.sendCode();
          }
        })
        .catch(err => {
          this.$Message.error({
            content: err.msg,
            duration: 6,
            closable: true
          });
        });
    },
    getUserInfo() {
      getUserInfo().then(res => {
        this.formValidate.phone = res.data.phone;
        let phone = res.data.phone;
        let reg = /^(\d{3})\d*(\d{4})$/;
        this.phone = phone.replace(reg, "$1****$2");
      });
    },
    confirm() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          const params = {
            account: this.formValidate.phone,
            captcha: this.formValidate.checkNum,
            password: this.formValidate.password,
            code: this.keyCode
          };
          registerReset(params).then(res => {
            if (res.status === 200) {
              this.$Message.success({
                content: "修改成功",
                duration: 6,
                closable: true
              });
            }
          });
        } else {
          this.$Message.error({
            content: "修改失败",
            duration: 6,
            closable: true
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.form /deep/ .ivu-input-large
  line-height 60px
.title
  font-size 20px
  letter-spacing 1px
  text-align center
  height 56px
  line-height 56px
  margin-bottom 20px
.form
  width 500px
  margin 0 auto
.btn
  width 200px
  height 40px
  line-height 40px
  background #3283de
  margin 0 auto
  text-align center
  color #fff
  font-size 16px
  border-radius 4px
  cursor pointer
</style>
